/**
 * Puck Renderer Component
 * 
 * Renders Puck page data for customer-facing store pages
 * This runs client-side - no server needed
 */

import { Render } from '@measured/puck'
import { puckConfig, type PuckData } from '../lib/puck'

interface PuckRendererProps {
  data: PuckData
}

function PuckRenderer({ data }: PuckRendererProps) {
  if (!data || !data.content) {
    return null
  }

  return (
    <div className="puck-rendered-page">
      <Render config={puckConfig} data={data} />
    </div>
  )
}

export default PuckRenderer
